<template>
	<div
		:class="[
			showAlertBanner ? 'min-h-page-alert' : 'min-h-page-header',
			'flex flex-col'
		]"
	>
		<div class="flex flex-col grow">
			<div class="h-full flex flex-col items-center grow bg-default w-full max-w-screen overflow-x-hidden">
				<slot name="default" />
			</div>
			<AppFooter />
		</div>
	</div>
</template>

<script setup lang="ts">
defineProps({
	showAlertBanner: {
		type: Boolean,
		default: true
	}
})
</script>
